export default {
  satisfies(targetValue, value1, includesValue1) {
    if (value1 == null) {
      return null;
    }
    return includesValue1 ? targetValue <= value1 : targetValue < value1;
  }
};